module.exports = __webpack_public_path__ + "img/skillgames-board.c60b7d2a.jpg";